const NoSubscription = () => {
    return (
        <div>
            <div className="text-xl font-bold leading-tight mb-4">
                No Subscription yet.
            </div>
            <div>To get started, choose a plan below.</div>
        </div>
    );
};

export default NoSubscription;
